module.exports = __webpack_public_path__ + "assets/img/import_component_custom.b3f46673.jpg";